import React from "react";
import { getCustomizationsRoot } from "../../util/commonFunctions";

const getApplicationUrl = (details) => {
  return details?.Encompass_Application_URL__c || details?.GA_Encompass_Application_URL__c || "";
};

export default function BottomBar({ currentUser }) {
  const details = currentUser?.details;
  const customizations = getCustomizationsRoot(currentUser);
  const primaryPhone = details?.Marketing_Number__c || details?.Phone;
  const officePhone = details?.Marketing_Number__c && details?.Phone ? details.Phone : null;
  const applicationUrl = getApplicationUrl(details);
  const bookingUrl = customizations?.options?.bookingLink;
  const secondaryColor = currentUser?.branding?.secondaryColor ? `#${currentUser.branding.secondaryColor}` : "#2D536F";
  const buttonColor = currentUser?.branding?.primaryButtonColor
    ? `#${currentUser.branding.primaryButtonColor}`
    : "#9A1B64";
  const secondaryButtonColor = currentUser?.branding?.secondaryButtonColor
    ? `#${currentUser.branding.secondaryButtonColor}`
    : "#5F88A9";

  return (
    <div className="z-40 shadow-lg md:sticky md:top-0" style={{ backgroundColor: secondaryColor }}>
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-4 px-4 py-3 md:flex-nowrap md:justify-between md:px-6">
        <div className="flex items-center justify-center gap-3 text-center md:justify-start md:text-left">
          {details?.Website_Headshot__c ? (
            <div className="hidden md:block h-10 w-10 overflow-hidden rounded-full border-2 border-white/40 bg-slate-300">
              <img
                src={details.Website_Headshot__c}
                alt={`${details?.FirstName || "MLO"} headshot`}
                className="h-full w-full object-cover"
              />
            </div>
          ) : null}
          <div>
            <p className="text-sm font-bold text-white md:text-base">
              {details?.FirstName} {details?.LastName}
            </p>
            {details?.Title ? <p className="text-xs text-white/70">{details.Title}</p> : null}
          </div>
        </div>

        <div className="flex w-full flex-col items-center justify-center gap-y-1 text-center md:w-auto md:flex-row md:gap-0 md:divide-x md:divide-white/30 md:text-left">
          {details?.LoanForce__NMLS_Number__c ? (
            <span className="text-sm text-white/90 md:px-3">NMLS# {details.LoanForce__NMLS_Number__c}</span>
          ) : null}
          {primaryPhone ? (
            <a className="text-sm text-white/90 hover:text-white md:px-3" href={`tel:${primaryPhone}`}>
              {primaryPhone}
            </a>
          ) : null}
          {officePhone ? (
            <a className="text-sm text-white/90 hover:text-white md:px-3" href={`tel:${officePhone}`}>
              {officePhone}
            </a>
          ) : null}
          {details?.Email ? (
            <a
              className="break-all text-sm text-white/90 hover:text-white md:px-3 md:break-normal"
              href={`mailto:${details.Email}`}
            >
              {details.Email}
            </a>
          ) : null}
        </div>

        <div className="flex w-full flex-wrap justify-center gap-3 md:w-auto md:justify-end">
          {applicationUrl ? (
            <a
              href={applicationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-xs rounded-md px-5 py-2 text-center text-sm font-bold uppercase tracking-wider text-white transition-transform duration-200 hover:-translate-y-0.5 md:w-auto"
              style={{ backgroundColor: buttonColor }}
            >
              Apply Now
            </a>
          ) : null}
          {bookingUrl ? (
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-xs rounded-md px-5 py-2 text-center text-sm font-bold uppercase tracking-wider text-white transition-transform duration-200 hover:-translate-y-0.5 md:w-auto"
              style={{ backgroundColor: secondaryButtonColor }}
            >
              Book Appointment
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
